import BaseLayer from 'ol/layer/Base';
import { useEffect } from 'react';
import { useOpenLayersContext } from './OpenLayersContext';
import { useLayers } from './layerManagement/LayerContext';

export function useElement(
  element: BaseLayer,
  name: string,
  isRemovableFromLayerControl = false,
  canZoomToFromLayerControl = false,
  properties?: Record<string, any>,
  id?: string,
) {
  const context = useOpenLayersContext();
  const { addLayer, removeLayer } = useLayers();

  useEffect(() => {
    addLayer(
      element,
      name,
      isRemovableFromLayerControl,
      canZoomToFromLayerControl,
      false,
      properties,
      id,
    );

    return () => {
      removeLayer(element);
    };
  }, [addLayer, removeLayer, context, element, name]);
}

export function useBaseElement(element: BaseLayer, name: string) {
  const context = useOpenLayersContext();
  const { addBaseLayer, removeLayer } = useLayers();

  useEffect(() => {
    addBaseLayer(element, name);

    return () => {
      removeLayer(element);
    };
  }, [addBaseLayer, removeLayer, context, element, name]);
}
